import { BlueDotIcon, ConfirmedGreenDot, GrayDotIcon, GreenDot, OrangeDotIcon, PinkDot, PurpleDot, RedDotIcon } from '../../assets/images';
export default function StatusColor(props) {
    var status = props.status;
    var getStatusMessage = function (status) {
        var icon;
        switch (status) {
            case 'Scheduled':
            case "Open":
                icon = BlueDotIcon;
                break;
            case 'Delay':
            case "Approval pending":
                icon = OrangeDotIcon;
                break;
            case 'Cancelled':
            case "Rejected":
                icon = RedDotIcon;
                break;
            case 'Inward':
            case "Approved":
                icon = GreenDot;
                break;
            case 'NoShow':
                icon = PinkDot;
                break;
            case 'Closed':
                icon = GrayDotIcon;
                break;
            case 'Confirmed':
                icon = ConfirmedGreenDot;
                break;
            case 'Reschedule':
                icon = PurpleDot;
                break;
            case 'Waiting':
                icon = GrayDotIcon;
                break;
            case 'Rework':
            case 'Cancelled':
                icon = RedDotIcon;
                break;
            case 'Started':
                icon = BlueDotIcon;
                break;
            case 'Completed':
            case 'Complete':
                icon = GreenDot;
                break;
            default:
                icon = GrayDotIcon;
                break;
        }
        return icon;
    };
    return /*#__PURE__*/ React.createElement("img", {
        src: getStatusMessage(status),
        alt: "settingIcon",
        style: {
            height: '7px',
            width: '7px'
        }
    });
}
